'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _reduxConnect = require('redux-connect');

var _components = require('../../components');
var _routerAdapter = require('../../helpers/routerAdapter');
var _realtor = require('../../redux/modules/realtor');







var _messageModal = require('../../redux/modules/messageModal');
var _propertyDetails = require('../../redux/modules/propertyDetails');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

RealtorPage = function (_Component) {_inherits(RealtorPage, _Component);function RealtorPage() {var _temp, _this, _ret;_classCallCheck(this, RealtorPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      showMessageModal: false }, _temp), _possibleConstructorReturn(_this, _ret);}RealtorPage.prototype.


  componentWillMount = function componentWillMount() {
    this.props.loadRealtorProps(this.props.realtorId);

    if (this.props.error && this.props.error.status === 404) {
      this.context.router.replace((0, _appendLocale2.default)(this.props.locale, '/404'));
    }
  };RealtorPage.prototype.

  componentWillUnmount = function componentWillUnmount() {
    this.props.reset();
  };RealtorPage.prototype.

  render = function render() {
    return (
      _react2.default.createElement(_components.Realtor, _extends({},
      this.props, {
        showMessageModal: this.state.showMessageModal })));


  };return RealtorPage;}(_react.Component);


RealtorPage.propTypes = {
  locale: _propTypes2.default.string,
  realtorId: _propTypes2.default.string.isRequired,
  error: _propTypes2.default.object,
  loadRealtorProps: _propTypes2.default.func.isRequired,
  reset: _propTypes2.default.func };


RealtorPage.contextTypes = {
  router: _propTypes2.default.object.isRequired };


var asyncData = [{
  key: 'fetchRealtorData',
  promise: function promise(_ref) {var realtorId = _ref.params.realtorId,dispatch = _ref.store.dispatch;return dispatch((0, _realtor.loadRealtor)(realtorId));} }];


var mapStateToProps = function mapStateToProps(store, _ref2) {var routeParams = _ref2.routeParams;
  var routeData = (0, _routerAdapter.extractRouteData)(store.routing, store.lang.locale);

  return {
    locale: routeData.locale,
    isMobile: store.windowDimentions.isMobile,
    translate: (0, _reduxPagan.getLang)(store.lang, 'static'),
    realtorId: routeParams.realtorId,
    realtor: store.realtor.data,
    error: store.realtor.error,
    properties: store.realtor.properties,
    mobileContactUsIsOpen: store.realtor.mobileContactUsIsOpen,
    userId: store.userAuthentication.userIsAuthorized && store.userAuthentication.data.id,
    formSubmitted: store.realtor.formSubmitted,
    formSubmitting: store.realtor.formSubmitting,
    formError: store.realtor.formError };

};

var mapDispatchToProps = {
  loadRealtorProps: _realtor.loadRealtorProps,
  openRealtorContactUsForm: _realtor.openRealtorContactUsForm,
  closeRealtorContactUsForm: _realtor.closeRealtorContactUsForm,
  openDetailsPopup: _propertyDetails.openDetailsPopup,
  sendRealtorContactUsForm: _realtor.sendRealtorContactUsForm,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  reset: _realtor.reset };exports.default =


(0, _ramda.compose)(
(0, _reduxConnect.asyncConnect)(asyncData),
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
RealtorPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/RealtorPage/RealtorPage.js
// module id = 3125
// module chunks = 0